import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../shell/PublicLayout";
import Overline from "../components/Overline";
import { paths } from "../routing/paths";

/*
 * /donations — the giving page in the redesign: breadcrumbs, title block,
 * the Keela giving form (same embed as before) in a white card, and a
 * navy Chai Club / offline-giving aside. Keela's global script watches the
 * DOM for `.keela-embed-form`; we also call its init on mount so the form
 * renders reliably after client-side navigation.
 */

const KEELA_FORM = "https://give-usa.keela.co/embed/XfwzpxcvtX9Wvg3JX";

export default function DonationPage() {
  useEffect(() => {
    try {
      window.KeelaForms?.initEmbeddedForms?.();
    } catch (_) {
      /* the script's own observer will pick the form up */
    }
  }, []);

  return (
    <PublicLayout>
      <main className="max-w-[1280px] w-full mx-auto px-5 pt-5 pb-10 flex flex-col gap-5">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-[14px] leading-5 whitespace-nowrap">
          <Link to={paths.home()} className="text-ic-blue font-semibold py-3 px-1 -my-3 inline-flex items-center min-h-[44px] hover:underline">
            Home
          </Link>
          <span className="text-ic-slate">→</span>
          <span className="text-ic-body font-semibold px-1">Donate</span>
        </nav>

        <section className="flex flex-col gap-2">
          <Overline>Support</Overline>
          <h1 className="m-0 font-extrabold text-black tracking-[-0.5px]" style={{ fontSize: "clamp(26px, 6vw, 40px)", lineHeight: 1.2 }}>
            Donate Now
          </h1>
          <p className="m-0 text-[18px] font-normal leading-7 text-ic-body max-w-[720px]">
            Inside Chassidus is a nonprofit. Your gift helps us record more classes and expand our reach.
          </p>
        </section>

        <section className="grid gap-5 items-start grid-cols-1 lg:grid-cols-[minmax(0,2fr)_minmax(280px,1fr)]">
          <div data-testid="donation-form" className="bg-ic-navy border border-white/10 rounded-xl shadow-ic-raised-dark p-4 sm:p-6 min-w-0">
            <div className="keela-embed-form" data-src={KEELA_FORM}>
              <div className="keela-loading" aria-label="Loading the donation form" role="status">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="bg-ic-navy border border-white/10 rounded-xl shadow-ic-raised-dark p-6 flex flex-col gap-3">
              <span className="text-[12px] font-bold leading-4 tracking-[0.5px] uppercase text-ic-lightGray">Chai Club</span>
              <p className="m-0 text-[16px] leading-6 text-white">
                Partner with the learning every month. Select <strong>monthly</strong> in the form to join
                the Chai Club with a recurring gift.
              </p>
              <Link to={paths.chaiClub()} className="text-ic-sky text-[16px] font-semibold underline inline-flex items-center min-h-[44px]">
                About the Chai Club →
              </Link>
            </div>
            <div className="bg-white border border-ic-lightGray rounded-xl shadow-ic-raised p-6 flex flex-col gap-2">
              <span className="text-[12px] font-bold leading-4 tracking-[0.5px] uppercase text-ic-slate">Prefer not to give online?</span>
              <p className="m-0 text-[16px] leading-6 text-ic-body">
                Contact us and we'll send you instructions for other ways to give.
              </p>
              <Link to={paths.contact()} className="text-ic-blue text-[16px] font-semibold underline inline-flex items-center min-h-[44px]">
                Contact us →
              </Link>
            </div>
          </aside>
        </section>
      </main>
    </PublicLayout>
  );
}
